<template>
  <v-container fluid>
    <v-layout class="mb-3">
      <v-flex xs12>
        <v-card > 
          <v-card-text class="text-xs-center">
            <h1>{{$tc('tokens.balance', this.tokens, {nbr: this.tokens})}}</h1>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-card class="mb-4">
      <v-toolbar card color="primary" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{$t('tokens.orders')}}</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="$t('general.search')"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
        <v-spacer></v-spacer>
      </v-card-title>
      <data-table
        :disableInitalSort="true"
        :loading="ordersLoading"
        :items="formatedOrdersList"
        :headers="ordersHeaders"
        :search="search"
        :selectAll="false"
        :action="false"
        @logo="openBill"
        returnValue="bill"
      ></data-table>
    </v-card>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Config from '@/config'
import DataTable from "@/components/DataTable";

export default {

  name: "Tokens",

  components: {
    DataTable
  },

  data() {
    return {
      search: "",
      tokens: 0
    };
  },

  async mounted() {
    this.getAllOrders();
    let res = await this.getTokenNumber(this.user.instance._id)
    this.tokens = res.tokens
    setTimeout(() => this.showAddButton = true, 500)
  },

  methods: {
    openBill(item) {
      window.open(this.config.filesUrl + this.user.instance._id + '/bills/' + item, '_blank')
    },

    ...mapActions('orders', {
      getAllOrders: 'getAll',
      getTokenNumber: 'getTokenNumber'
    })

  },

  computed: {

    formatedOrdersList () {
      return this.allOrder.map(order => {
        order.statusName = this.orderStatus[order.status]
        order.createdAtFormated = new Date(order.createdAt).toLocaleDateString()
        order.billLogo = "picture_as_pdf"
        return order 
      })
    },

    config () {
      return Config
    },

    ...mapGetters('orders', {
      orderStatus: 'status',
      allOrder: 'list',
      ordersHeaders: 'headers',
      ordersLoading: 'loading'
    }),

    ...mapGetters('user', {
      user: 'current'
    })
  }
};
</script>
